module.exports = __webpack_public_path__ + "static/media/Nokia 220 White.4e8c869b.png";